module.exports = {
    // base_url:"http://intellivent.id:9999"
    // base_url: "http://localhost:11234/"
    // base_url : "https://coopsmile-api.intellivent.id/"
    // base_url: 'https://sihapei-api.intellivent.id/',
    base_url: 'https://sihapei-api.komunestudio.com/',
    // base_url: 'https://sihapei-api.hpi.or.id/',
}
